// export const GET_INSURANCE = 'GET_INSURANCE';
// export const UPDATE_DEVICE_INFO = 'UPDATE_DEVICE_INFO';
// export const UPDATE_CREATE_QUOTE = 'UPDATE_CREATE_QUOTE';
// export const SELECT_INSURANCE_TYPE = 'SELECT_INSURANCE_TYPE';
// export const SET_ATTEMPTS = 'SET_ATTEMPTS';
// export const SEND_LINK_SUCCESS = 'SEND_LINK_SUCCESS';
// export const SEND_LINK_ERROR = 'SEND_LINK_ERROR';
// export const UPDATE_POLICYNUMBER = 'UPDATE_POLICYNUMBER';
// export const STORE_PAYMENT_LINK = 'STORE_PAYMENT_LINK';

export const AUTH_USER = "AUTH_USER";
export const AGENT_DATA = "AGENT_DATA";
export const ROOT_AGENT_DATA = "ROOT_AGENT_DATA";

export const ADD_CAR_POLICY_DETAIL = "ADD_CAR_POLICY_DETAIL"

export const ADD_CREATE_QUOTE_DETAILS = "ADD_CREATE_QUOTE_DETAILS"
export const ADD_KEY = "ADD_KEY"
//for storing keyvalue pairs of policy details
export const ADD_TEMP_ITEM = "ADD_TEMP_ITEM"
export const CLEAR_QUOTE_STATE = "CLEAR_QUOTE_STATE"


export const UPLOAD_IMAGE_DATA = "UPLOAD_IMAGE_DATA"
export const ACTION_TYPE_SENSOR_DATA = "TYPE_SENSOR_DATA"